import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { EFCategory } from '../efCategory.model';
import { EfcategoryService } from '../efcategory.service';

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.css']
})
export class CategoryListComponent implements OnInit {

  Categories: EFCategory[] = [];
  displayedColumns: string[] = ['id', 'arabicName', 'englishName', "edit"];
  dataSource!: MatTableDataSource<EFCategory>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  category: EFCategory = {} as EFCategory;
  Catgstatus: { id: number, name: string }[] = [];

  selectedStatus: number = 1;
  imagPath: any;
  pageSize = 100;
  constructor(private service: EfcategoryService,
    private router: Router,
    private localStorage: LocalStorageService,
    private globle: Globle,
    private translate: TranslateService) {
    var lang = this.localStorage.retrieve("lang");
    lang == 0 ? this.translate.use('en') : this.translate.use('ar');
  }

  ngOnInit() {
    this.Catgstatus = [{ id: 1, name: this.translate.instant("active") }, { id: 0, name: this.translate.instant("notActive") }];
    this.selectedStatus = 1;
    this.pageSize = this.globle.pageSize;
    this.getCategory();

  }


  getCategory() {
    this.spinnerOverlay = true;
    this.service.getAll(this.selectedStatus).subscribe(data => {
      this.Categories = data.sort((n1, n2) => n2.id - n1.id);

      this.dataSource = new MatTableDataSource(this.Categories);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  edit(id: number) {
    this.router.navigate(['./master/efawateercome/efcategoriesForm/' + id]);
  }


  selectChange() {
    this.getCategory();
  }

}
